const SexoValues = [
  {
    label: "Masculino",
    value: 'M'
  },
  {
    label: "Feminino",
    value: 'F'
  }
];

export {SexoValues};
